<template>
    <div class="transition  duration-150 ease-in-out  w-10/12 md:w-2/5">
        <div class="w-full bg-white rounded shadow-2xl">
            <div class="relative bg-gray-200 rounded-t py-4 px-4 xl:px-8">
                <svg class="hidden md:block absolute -ml-5 -mb-10 left-0 bottom-0" width="30px" height="30px" viewBox="0 0 9 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Tooltips-" transform="translate(-874.000000, -1029.000000)" fill="#FFFFFF">
                            <g id="Group-3-Copy-16" transform="translate(850.000000, 975.000000)">
                                <g id="Group-2" transform="translate(24.000000, 0.000000)">
                                    <polygon id="Triangle" transform="translate(4.500000, 62.000000) rotate(-90.000000) translate(-4.500000, -62.000000) " points="4.5 57.5 12.5 66.5 -3.5 66.5"></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <svg class="absolute top-0 -mt-5 block md:hidden" xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 26 23" fill="none">
                    <path id="Polygon 2" d="M13 0L25.9904 22.5H0.00961876L13 0Z" fill="#e5e7eb"/>
                </svg>
                <p class="text-base text-gray-800 font-normal leading-normal tracking-normal">{{ props.filter.name }}</p>
            </div>
            <div class="w-full h-full px-4 xl:px-8 py-5">
                <div class="flex items-center my-2">
                    <input v-model="value" type="text" class="px-2 py-2 w-full border-[#d1d5db] bg-face-haze rounded-lg border-[1px] focus:border-indigo-500 transition ease-in-out duration-300">
                </div>
                <div class="inline-flex space-x-[20px] justify-center items-center mt-[20px]">
                    <button @click="handleCancel" class="inline-flex items-center px-8 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-black bg-face-haze">
                        Cancel
                    </button>
                    <button @click="handleSubmit" class="bg-indigo-500 shadow-md shadow-indigo-500/50 px-8 py-2 text-white font-bold text-xs rounded-md transition duration-150 ease-in-out">Apply</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";

const props = defineProps({filter: Object})
const value = ref('')
const emit = defineEmits(['apply', 'cancel'])

const handleSubmit = () => {
    emit('apply', Object.assign(props.filter, {value: value.value}))
}

const handleCancel = () => {
    emit('cancel')
}

</script>
